// extracted by mini-css-extract-plugin
module.exports = {"criticalError":"errorSummary_criticalError__3u94O"};